import ExamResults from "./ExamResults";

export default class ExamPointsCalculator {

    private readonly test1Results: ExamResults;
    private readonly test2Results: ExamResults;
    private readonly finalExamResults: ExamResults;

    constructor(test1Results: ExamResults | undefined,
                test2Results: ExamResults | undefined,
                finalExamResults: ExamResults | undefined) {

        this.test1Results = test1Results ?? new ExamResults();
        this.test2Results = test2Results ?? new ExamResults();
        this.finalExamResults = finalExamResults ?? new ExamResults();
    }

    test1ResultsExist(): boolean {
        return exists(this.test1Results);
    }

    test2ResultsExist(): boolean {
        return exists(this.test2Results);
    }

    finalExamResultsExist(): boolean {
        return exists(this.finalExamResults);
    }

    examResultsExist(): boolean {
        return this.getTotalPoints() !== undefined;
    }

    getTest1Points(): number | undefined {
        return exists(this.test1Results)
            ? this.test1Results.getPoints()
            : undefined;
    }

    getTest2Points(): number | undefined {
        return exists(this.test2Results)
            ? this.test2Results.getPoints()
            : undefined;
    }

    getFinalExamPoints(): number | undefined {
        return exists(this.finalExamResults)
            ? this.finalExamResults.getPoints()
            : undefined;
    }

    getTotalPoints(): number {
        if (exists(this.finalExamResults)
            && this.finalExamResults.version === 'AB') {

            return this.finalExamResults.getPoints();
        }

        let test1Points = this.getTest1Points() ?? 0;
        if (exists(this.finalExamResults)
            && this.finalExamResults.version === 'A') {
            test1Points = this.finalExamResults.getPoints();
        }

        let test2Points = this.getTest2Points() ?? 0;
        if (exists(this.finalExamResults)
            && this.finalExamResults.version === 'B') {
            test2Points = this.finalExamResults.getPoints();
        }

        return test1Points + test2Points;
    }
}

function exists(results: ExamResults): boolean {
    return results && results.theory.length > 0;
}
